import React, { useEffect, useState } from "react";
import changeItemMoreSale from "../api/changeItemMoreSale";
import changeItemStatus from "../api/changeItemStatus";
import ItemExpandRegionPop from "./ItemExpandRegionPop";
import ItemExpandUpdatingPicture from "./ItemExpandUpdatingPicture";

// Item Expand Row
const ItemExpandRow = ({ item }) => {
  const [name, setName] = useState("");
  const [iraqiPrice, setIraqiPrice] = useState("");
  const [moreSale, setMoreSale] = useState(item.moresale === 1);
  const [isAvailable, setIsAvailable] = useState(item.status === 1);
  const [expandItemRegion, setExpandItemRegion] = useState(null);
  const [expandingPicture, setExpandingPicture] = useState(null);
  const [imageVersion, setImageVersion] = useState(Date.now());
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const openConfirmationModal = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setShowConfirmationModal(true);
  };
  const closeConfirmationModal = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setShowConfirmationModal(false);
  };

  const handleChangeItemStatus = async (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    const statusChanged = await changeItemStatus({ itemId: item.id, itemStatus: "2" });
    if (statusChanged) {
    } else {
    }
    closeConfirmationModal();
  };

  // Setting all Property for Item
  useEffect(() => {
    setName(item.name);
    setIraqiPrice(item.iraqiprice);
    // setMoreSale();
    // setIsAvailable();
  }, [item]);

  // toggle for Expand Regions Item
  // Function to toggle the expandable row for a specific order
  const toggleExpandRegion = (itemId) => {
    if (expandItemRegion === itemId) {
      setExpandItemRegion(null); // Collapse the row if it's already expanded
    } else {
      setExpandItemRegion(itemId);
      setExpandingPicture(null);
    }
  };

  const toggleExpandPicture = (itemId) => {
    if (expandingPicture === itemId) {
      setExpandingPicture(null); // Collapse the row if it's already expanded
    } else {
      setExpandingPicture(itemId);
      setExpandItemRegion(null);
    }
  };

  const handleChangeStatus = async (e) => {
    const itemStatus = e.target.checked ? "1" : "0";
    await changeItemStatus({
      itemId: item.id,
      itemStatus: itemStatus,
    });
    setIsAvailable(itemStatus === "1" ? true : false);
  };
  const handleChangeMoreSale = async (e) => {
    const itemMoreSale = e.target.checked ? "1" : "0";
    await changeItemMoreSale({
      itemId: item.id,
      itemMoreSale: itemMoreSale,
    });
    setMoreSale(itemMoreSale === "1" ? true : false);
  };

  return (
    <>
      {
        <tr className="bg-gray-100 border-b">
          <td className="px-6 py-4">
            <button
              className="text-red-500 hover:text-red-700 font-bold text-md"
              onClick={() => openConfirmationModal()}
            >
              حذف
            </button>
            {showConfirmationModal && (
              <div className="modal-overlay">
                <div className="modal-content">
                  <p>هل أنت متأكد من أنك تريد حذف هذا المنتج؟</p>
                  <button
                    onClick={handleChangeItemStatus}
                    className=" my-2 w-32 px-3 py-2 text-sm font-medium text-center text-white bg-red-700 rounded-lg hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300"
                  >
                    نعم
                  </button>

                  <button
                    onClick={closeConfirmationModal}
                    className=" my-2 w-32 px-3 py-2 text-sm font-medium text-center text-white bg-red-700 rounded-lg hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300"
                  >
                    لا
                  </button>
                </div>
              </div>
            )}
          </td>
          <td className="px-6 py-4">
            <button
              className="text-blue-500 hover:text-blue-700 font-bold text-md"
              onClick={() => toggleExpandPicture(item.id)}
            >
              {expandingPicture ? "إخفاء" : "تعديل"}
            </button>
          </td>
          <td className="px-6 py-4">
            <input type="checkbox" checked={isAvailable} onChange={handleChangeStatus} />
          </td>
          <td className="px-8 py-4">
            <input
              type="number"
              className="py-2 px-2 rounded"
              value={iraqiPrice}
              onChange={(e) => {
                setIraqiPrice(e.target.value);
              }}
              min="0"
              dir="rtl"
            />
          </td>
          <td className="px-6 py-4">
            <button
              className="text-blue-400 underliner"
              onClick={() => {
                toggleExpandRegion(item.id);
              }}
              type="button"
            >
              المناطق الخاصة بالمنتج
            </button>
            {expandItemRegion === item.id ? (
              <ItemExpandRegionPop item={item} setExpandItemRegion={setExpandItemRegion} />
            ) : (
              ""
            )}
          </td>
          <td className="px-6 py-4">
            <input
              type="checkbox"
              name="moresale"
              checked={moreSale}
              onChange={handleChangeMoreSale}
            />
          </td>

          <th scope="row" colSpan="3" className="px-6 text-gray-900 whitespace-nowrap text-right">
            <input
              type="text"
              name="name"
              className="py-2 px-2 rounded text-sm w-full"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
              }}
              dir="rtl"
            />
          </th>
          <th className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap flex items-right justify-right">
            <img
              src={`${process.env.REACT_APP_IMAGE_URL}/${item.image}.png?v=${imageVersion}`}
              alt="Item "
              className="w-16 h-16 object-cover object-center"
            />
          </th>
        </tr>
      }
      {expandingPicture === item.id ? (
        <ItemExpandUpdatingPicture
          item={item}
          onImageUpdated={() => setImageVersion(Date.now())}
          showAllFields={true}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default ItemExpandRow;
